import React, {useCallback, useMemo} from 'react';
import {Box, Tag, TagLabel, useColorMode, useToken, Text, useColorModeValue} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {designSystemColors} from 'theme';
import { useColorModeValueKey } from 'hooks/useColors';

const StatusTag = (props) => {
    const {status} = props;
    const {t, i18n} = useTranslation('app');
    const colorMode = 'light';
    const textColor = useColorModeValueKey('navTextActived');

    const getSchema = useCallback(
        (status) => {
            switch (status) {
                case 'actived':
                case 'Activated':
                case 'configed':
                case 'online':
                case 'activated':
                case 'completed':
                case 'processed':
                case 'passed':
                case 'approved':
                case 'replyed':
                case 'verified':
                case 'success':
                case 'enable':
                case 'attempted':
                case 'contacted':
                case 'interested':
                case 'valid':
                case 'true':
                    return `success`;

                case 'pending':
                case 'renewPending':
                case 'processing':
                case 'inactive':
                case 'unReplyed':
                case 'unregistered':
                case 'new':
                case 'In review':
                case 'Final review':
                case 'Card mailed':
                    return `pending`;

                case 'error':
                case 'failed':
                case 'invalid':
                case 'declined':
                case 'Declined':
                    return `error`;

                case 'renew':
                case 'draft':
                case 'return':
                case 'Draft':
                case 'Returned':
                case 'Withdrawn':
                case 'Cancelled':
                case 'cancelled':
                case 'noInterested':
                    return `warning`;

                case 'offline':
                case 'unconfiged':
                case 'suspended':
                case 'disable':
                case 'converted':
                case 'false':
                case 'returned':
                    return 'gray';
            }
        },
        [colorMode],
    );

    const bg = useColorModeValueKey(getSchema(status));
    const item = useMemo(
        () => (
            <Box size={'base'} borderRadius={'base'} py={0.5} color={'#fff'} px={2} display={'inline-block'} variant="solid" bg={bg}>
                <Text fontSize={'2xs'} color={textColor} fontWeight={600}>{t(status)}</Text>
            </Box>
        ),
        [colorMode, status, i18n.language],
    );
    return item;
};

export default StatusTag;
